import React from 'react';
import { styled } from '@linaria/react';
import queryString from 'query-string';
import sanitizeHtml from 'sanitize-html';

import { ModalRef } from '@blocks/ui/modal';
import { isBrowser } from '@blocks/utils';

import { Button, Modal } from '../../ui';

const CloseOAuth2ErrorModalButton = styled(Button)`
  margin-top: 16px;
`;

const getMessageString = (message: string | (string | null)[] | null): string => {
  if (Array.isArray(message)) {
    return message.filter(Boolean).join(' ');
  }

  if (!message) {
    return 'Some error occurred. Please try again later or contact support.';
  }

  return message;
};

const removeDataFromUrl = () => {
  if (isBrowser()) {
    const url = new URL(window.location.href);
    url.searchParams.delete('error');
    url.searchParams.delete('slug');
    url.searchParams.delete('message');
    window.history.replaceState({}, document.title, url.toString());
  }
};

const OAuth2ErrorModal = () => {
  const messageModal = React.useRef<ModalRef>(null);
  const [message, setMessage] = React.useState<string>('');

  React.useEffect(() => {
    if (isBrowser()) {
      const { error, message } = queryString.parse(window.location.search);

      if (error === 'oauth2') {
        messageModal.current?.open();
        setMessage(sanitizeHtml(getMessageString(message)));
      }
    }
  }, []);

  return (
    <Modal
      ref={messageModal}
      title={'Oops! Something went wrong'}
      afterClose={removeDataFromUrl}
    >
      {message}
      <CloseOAuth2ErrorModalButton
        onClick={() => {
          messageModal.current?.close();
        }}
      >
        Ok
      </CloseOAuth2ErrorModalButton>
    </Modal>
  );
};

export default OAuth2ErrorModal;
